import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Background from "../components/common/Background";
import LoadingPage from "../pages/LoadingPage";
import OnboardingPage from "../pages/OnboardingPage";
import ProfilePage from "../pages/ProfilePage";
import NatalChartPage from "../pages/NatalChartPage";
import Forecast from "../pages/Forecast";
import AstrologPage from "../pages/Astrolog";

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Background
        starDensity={600} // Меньше значение = больше звезд
        nebulaIntensity={0.7} // Интенсивность туманности (0.1-1)
        starColors={{
          main: "rgba(180, 200, 255, 0.8)",
          bright: "rgba(255, 230, 180, 0.97)",
          shooting: "rgba(100, 200, 255, 0.95)",
        }}
      />
      <Routes>
        <Route path="/" element={<LoadingPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/natal-chart" element={<NatalChartPage />} />
        <Route path="/forecast" element={<Forecast />} />
        <Route path="/astrolog" element={<AstrologPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
